:host([noEscapeSpaceInTitle]) {
  .title {
    text-indent: -1px;
    white-space: pre;
  }
}
